import { ReactNode } from "react";
import { get, isEmpty, map } from "lodash";
import { UseFieldArrayReturn, useFormContext } from "react-hook-form";
import DateTimePicker from "../../shared/form/fields/DateTimePicker";
import ScheduleTimeField from "./ScheduleTimeField";
import classNames from "classnames";

type ScheduleFieldsArgs = {
  fields: UseFieldArrayReturn["fields"];
  removeButton: (index: number) => ReactNode;
};

export default function ScheduleFields({
  fields,
  removeButton,
}: ScheduleFieldsArgs) {
  const {
    formState: { errors },
    watch,
  } = useFormContext();

  return (
    <>
      {map(fields, (field, index) => {
        const date = watch(`object.proposals.${index}.date`);
        return (
          <ScheduleField
            key={field.id}
            dateName={`object.proposals.${index}.date`}
            timeName={`object.proposals.${index}.time`}
            timeEndName={`object.proposals.${index}.time_end`}
            removeButton={() => removeButton(index)}
            errors={errors}
            date={date}
          />
        );
      })}
    </>
  );
}

type ScheduleFieldArgs = {
  errors?: unknown;
  date?: string;
  dateName: string;
  timeName: string;
  timeEndName: string;
  removeButton?: () => ReactNode;
  allowEmptyTime?: boolean;
};

export function ScheduleField({
  errors,
  date,
  dateName,
  timeName,
  timeEndName,
  removeButton,
  allowEmptyTime,
}: ScheduleFieldArgs) {
  return (
    <div className="add-schedule-option grid grid-cols-[2fr_0.5fr_auto_0.5fr_auto] gap-2 items-center">
      <DateTimePicker
        name={dateName}
        dateClassName="w-full"
        dateInputClassName={classNames({
          "field-error field-error-live":
            !!get(errors, ["object", "proposals", "root", "message"]) &&
            isEmpty(date),
        })}
      />
      <ScheduleTimeField
        name={timeName}
        dateName={dateName}
        allowEmpty={allowEmptyTime}
      />
      -
      <ScheduleTimeField name={timeEndName} dateName={dateName} allowEmpty />
      {removeButton && removeButton()}
    </div>
  );
}
